/**
 * @generated SignedSource<<26d58d5c884f6ddd6bff726c8c378550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useWorkflowApplyActionToSubmissionMutation$variables = {
  action: string;
  property_batch_ids: ReadonlyArray<number>;
  submission_id: number;
};
export type useWorkflowApplyActionToSubmissionMutation$data = {
  readonly _sys_workflow_apply_bulk_action_to_submission: {
    readonly results: ReadonlyArray<{
      readonly error: string | null;
      readonly message: string | null;
      readonly property_batch_id: number;
    }>;
  };
};
export type useWorkflowApplyActionToSubmissionMutation = {
  response: useWorkflowApplyActionToSubmissionMutation$data;
  variables: useWorkflowApplyActionToSubmissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "property_batch_ids"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "submission_id"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "action",
            "variableName": "action"
          },
          {
            "kind": "Variable",
            "name": "property_batch_ids",
            "variableName": "property_batch_ids"
          },
          {
            "kind": "Variable",
            "name": "submission_id",
            "variableName": "submission_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "params"
      }
    ],
    "concreteType": "_sys_workflow_apply_bulk_action_to_submission_output",
    "kind": "LinkedField",
    "name": "_sys_workflow_apply_bulk_action_to_submission",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "_sys_workflow_bulk_action_result",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "error",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "property_batch_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkflowApplyActionToSubmissionMutation",
    "selections": (v3/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkflowApplyActionToSubmissionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "4be8daec59092a5d734a8e9e66022ea1",
    "id": null,
    "metadata": {},
    "name": "useWorkflowApplyActionToSubmissionMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkflowApplyActionToSubmissionMutation(\n  $submission_id: Int!\n  $property_batch_ids: [Int!]!\n  $action: String!\n) {\n  _sys_workflow_apply_bulk_action_to_submission(params: {submission_id: $submission_id, action: $action, property_batch_ids: $property_batch_ids}) {\n    results {\n      message\n      error\n      property_batch_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a82a297317896ee93cd50876473ddfc4";

export default node;
